import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ParametroGlobalContextService } from '@features/configuracion-global/parametros-globales/services/parametro-global-context.service';

export const permiteHorasExtraGuard: CanActivateFn = () => {
  const ctx = inject(ParametroGlobalContextService);
  const router = inject(Router);

  if (ctx.permiteHorasExtra()) return true;

  return router.createUrlTree(['/trabajadores/gestion-trabajadores']);
};
